import { useEffect } from 'react';
import { useHistory } from 'react-router';

import { RoutesHelper } from 'src/common/helpers/RoutesHelper';
import { ProductType } from 'src/common/interfaces/Tenant';
import { useConfiguration } from 'src/common/providers/configurationProvider/ConfigurationProvider';
import { useUserTenant } from 'src/common/providers/userTenantProvider/UserTenantProvider';
import { getMsdkV1DashboardBreadcrumbsRoutes } from 'src/common/services/breadcrumbs/MsdkUrlService';
import { getProductDashboardAccessPermission } from 'src/common/services/CommonDashboardService';
import { useBreadcrumbStore } from 'src/common/stores/BreadcrumbStore';

export const useSetMobileSdkV1Breadcrumbs = (): void => {
	const { updateBreadcrumbRoutes, setBreadcrumbRoutes } = useBreadcrumbStore();
	const { location } = useHistory();
	const { getToggle } = useConfiguration();
	const { tenant } = useUserTenant();

	useEffect(() => {
		if (
			location.pathname === RoutesHelper.getMobileSdkV1TestReportPathname() &&
			getProductDashboardAccessPermission(tenant, getToggle, ProductType.MOBILE_SDK)
		) {
			updateBreadcrumbRoutes(getMsdkV1DashboardBreadcrumbsRoutes(location));
		}

		return () => {
			setBreadcrumbRoutes([]);
		};
	}, [updateBreadcrumbRoutes, setBreadcrumbRoutes, location, tenant, getToggle]);
};
